export default {
  namespaced: true,
  state: {
    type: undefined,
    message: undefined,
  },
  mutations: {
    setSuccess(state, msg) {
      state.type = 'SUCCESS';
      state.message = msg;
    },
  },
  getters: {},
  actions: {
    success({
      commit,
    }, msg) {
      commit('setSuccess', msg);
    },
  },
};
